const countriesAndRegions: any = {
    countries: {
        AF: "Afghanistan",
        AX: "Ålandseilanden",
        AL: "Albanië",
        DZ: "Algerije",
        AS: "Amerikaans-Samoa",
        AD: "Andorra",
        AO: "Angola",
        AI: "Anguilla",
        AQ: "Antarctica",
        AG: "Antigua en Barbuda",
        AR: "Argentinië",
        AM: "Armenië",
        AW: "Aruba",
        AU: "Australië",
        AT: "Oostenrijk",
        AZ: "Azerbeidzjan",
        BS: "Bahama`s",
        BH: "Bahrein",
        BD: "Bangladesh",
        BB: "Barbados",
        BY: "Wit-Rusland",
        BE: "België",
        BZ: "Belize",
        BJ: "Benin",
        BM: "Bermuda",
        BT: "Bhutan",
        BO: "Bolivia",
        BA: "Bosnië en Herzegovina",
        BW: "Botswana",
        BV: "Bouveteiland",
        BR: "Brazilië",
        IO: "Brits Indische Oceaanterritorium",
        VG: "Britse Maagdeneilanden",
        BN: "Brunei",
        BG: "Bulgarije",
        BF: "Burkina Faso",
        BI: "Burundi",
        KH: "Cambodja",
        CM: "Kameroen",
        CA: "Canada",
        CV: "Kaapverdië",
        BQ: "Caribisch Nederland",
        KY: "Kaaimaneilanden",
        CF: "Centraal-Afrikaanse Republiek",
        TD: "Tsjaad",
        CL: "Chili",
        CN: "China",
        CX: "Christmaseiland",
        CC: "Cocoseilanden",
        CO: "Colombia",
        KM: "Comoren",
        CG: "Congo-Brazzaville",
        CD: "Congo-Kinshasa",
        CK: "Cookeilanden",
        CR: "Costa Rica",
        HR: "Kroatië",
        CU: "Cuba",
        CW: "Curaçao",
        CY: "Cyprus",
        CZ: "Tsjechische Republiek",
        DK: "Denemarken",
        DJ: "Djibouti",
        DM: "Dominica",
        DO: "Dominicaanse Republiek",
        EC: "Ecuador",
        EG: "Egypte",
        SV: "El Salvador",
        GQ: "Equatoriaal-Guinea",
        ER: "Eritrea",
        EE: "Estland",
        ET: "Ethiopië",
        FK: "Falklandeilanden",
        FO: "Faeröer",
        FJ: "Fiji",
        FI: "Finland",
        FR: "Frankrijk",
        GF: "Frans-Guyana",
        PF: "Frans-Polynesië",
        TF: "Franse Zuidelijke Gebieden",
        GA: "Gabon",
        GM: "Gambia",
        GE: "Georgia",
        DE: "Duitsland",
        GH: "Ghana",
        GI: "Gibraltar",
        GR: "Griekenland",
        GL: "Groenland",
        GD: "Grenada",
        GP: "Guadeloupe",
        GU: "Guam",
        GT: "Guatemala",
        GG: "Guernsey",
        GN: "Guinee",
        GW: "Guinee-Bissau",
        GY: "Guyana",
        HT: "Haïti",
        HM: "Heard en McDonaldeilanden",
        HN: "Honduras",
        HK: "Hong Kong",
        HU: "Hongarije",
        IS: "IJsland",
        IN: "India",
        ID: "Indonesië",
        IR: "Iran",
        IQ: "Irak",
        IE: "Ierland",
        IM: "Man (eiland)",
        IL: "Israël",
        IT: "Italië",
        CI: "Ivoorkust",
        JM: "Jamaica",
        JP: "Japan",
        JE: "Jersey",
        JO: "Jordanië",
        KZ: "Kazachstan",
        KE: "Kenia",
        KI: "Kiribati",
        KW: "Koeweit",
        KG: "Kirgizië",
        LA: "Laos",
        LV: "Letland",
        LB: "Libanon",
        LS: "Lesotho",
        LR: "Liberia",
        LY: "Libië",
        LI: "Liechtenstein",
        LT: "Litouwen",
        LU: "Luxemburg",
        MO: "China MO",
        MK: "Macedonië",
        MG: "Madagascar",
        MW: "Malawi",
        MY: "Maleisië",
        MV: "Malediven",
        ML: "Mali",
        MT: "Malta",
        MH: "Marshalleilanden",
        MQ: "Martinique",
        MR: "Mauritanië",
        MU: "Mauritius",
        YT: "Mayotte",
        MX: "Mexico",
        FM: "Micronesië",
        MD: "Moldavië",
        MC: "Monaco",
        MN: "Mongolië",
        ME: "Montenegro",
        MS: "Montserrat",
        MA: "Marokko",
        MZ: "Mozambique",
        MM: "Myanmar",
        NA: "Namibië",
        NR: "Nauru",
        NP: "Nepal",
        NL: "Nederland",
        AN: "Nederlandse Antillen",
        NC: "Nieuw-Caledonië",
        NZ: "Nieuw-Zeeland",
        NI: "Nicaragua",
        NE: "Niger",
        NG: "Nigeria",
        NU: "Niue",
        NF: "Norfolk (eiland)",
        MP: "Noordelijke Marianen",
        KP: "Noord-Korea",
        NO: "Noorwegen",
        OM: "Oman",
        PK: "Pakistan",
        PW: "Palau",
        PS: "Palestijnse gebieden",
        PA: "Panama",
        PG: "Papoea-Nieuw-Guinea",
        PY: "Paraguay",
        PE: "Peru",
        PH: "Filipijnen",
        PN: "Pitcairn",
        PL: "Polen",
        PT: "Portugal",
        PR: "Puerto Rico",
        QA: "Qatar",
        RE: "Réunion",
        RO: "Roemenië",
        RU: "Rusland",
        RW: "Rwanda",
        BL: "Saint-Barthélemy",
        SH: "Sint-Helena",
        KN: "Saint Kitts en Nevis",
        LC: "Saint Lucia",
        MF: "Sint-Maarten (Franse Antillen)",
        PM: "Saint-Pierre en Miquelon",
        VC: "Saint Vincent en de Grenadines",
        WS: "Samoa",
        SM: "San Marino",
        ST: "Sao Tomé en Principe",
        SA: "Saoedi-Arabië",
        SN: "Senegal",
        RS: "Servië",
        SC: "Seychellen",
        SL: "Sierra Leone",
        SG: "Singapore",
        SX: "Sint Maarten",
        SK: "Slowakije",
        SI: "Slovenië",
        SB: "Salomonseilanden",
        SO: "Somalië",
        ZA: "Zuid-Afrika",
        GS: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
        KR: "Zuid-Korea",
        SS: "Zuid-Soedan",
        ES: "Spanje",
        LK: "Sri Lanka",
        SD: "Soedan",
        SR: "Suriname",
        SJ: "Spitsbergen en Jan Mayen",
        SZ: "Eswatini",
        SE: "Zweden",
        CH: "Zwitserland",
        SY: "Syrië",
        TW: "Taiwan",
        TJ: "Tadzjikistan",
        TZ: "Tanzania",
        TH: "Thailand",
        TL: "Oost-Timor",
        TG: "Togo",
        TK: "Tokelau",
        TO: "Tonga",
        TT: "Trinidad en Tobago",
        TN: "Tunesië",
        TR: "Turkije",
        TM: "Turkmenistan",
        TC: "Turks- en Caicoseilanden",
        TV: "Tuvalu",
        VI: "Amerikaanse Maagdeneilanden",
        UG: "Oeganda",
        UA: "Oekraïne",
        AE: "Verenigde Arabische Emiraten",
        GB: "Verenigd Koninkrijk",
        US: "VS",
        UM: "Amerikaanse Kleinere Afgelegen Eilanden",
        UY: "Uruguay",
        UZ: "Oezbekistan",
        VU: "Vanuatu",
        VA: "Vaticaanstad",
        VE: "Venezuela",
        VN: "Vietnam",
        WF: "Wallis en Futuna",
        EH: "Westelijke Sahara",
        YE: "Jemen",
        ZM: "Zambia",
        ZW: "Zimbabwe",
    },
    regions: {
        "123": "Andalusië",
        "124": "Aragón",
        "125": "Asturië",
        "126": "Balearen",
        "127": "Baskenland",
        "128": "Canarische Eilanden",
        "129": "Cantabrië",
        "130": "Castilië en León",
        "131": "Castilië-La Mancha",
        "132": "Catalonië",
        "133": "Ceuta",
        "134": "Extremadura",
        "135": "Galicië",
        "136": "La Rioja (Spanje)",
        "137": "Madrid",
        "138": "Melilla",
        "139": "Murcia",
        "140": "Navarra",
        "141": "Valencia (autonome gemeenschap)",
        "142": "Attica",
        "143": "Centraal-Griekenland",
        "144": "Centraal-Macedonië",
        "145": "Kreta",
        "146": "Oost-Macedonië en Thracië",
        "147": "Epirus",
        "148": "Ionische Eilanden",
        "149": "Noord-Egeïsche Eilanden",
        "150": "Peloponnesos",
        "151": "Zuid-Egeïsche Eilanden",
        "152": "Thessalië",
        "153": "West-Griekenland",
        "154": "West-Macedonië",
        "155": "Aveiro",
        "156": "Beja",
        "157": "Braga",
        "158": "Bragança",
        "159": "Castelo Branco",
        "160": "Coimbra",
        "161": "Évora",
        "162": "Faro",
        "163": "Guarda",
        "164": "Leiria",
        "165": "Lissabon",
        "166": "Portalegre",
        "167": "Porto",
        "168": "Santarém",
        "169": "Santarém",
        "170": "Viana do Castelo",
        "171": "Vila-real",
        "172": "Viseu",
        "173": "North",
        "174": "Zuid",
        "175": "Centraal",
        "176": "Andamanen en Nicobaren",
        "177": "Andhra Pradesh",
        "178": "Arunachal Pradesh",
        "179": "Assam",
        "180": "Bihar",
        "181": "Chandigarh",
        "182": "Chhattisgarh",
        "183": "Dadra en Nagar Haveli",
        "184": "Daman en Diu",
        "185": "Goa",
        "186": "Gujarat",
        "187": "Haryana",
        "188": "Himachal Pradesh",
        "189": "Jammu en Kasjmir",
        "190": "Jharkhand",
        "191": "Karnataka",
        "192": "Kerala",
        "193": "Laccadiven",
        "194": "Madhya Pradesh",
        "195": "Maharashtra",
        "196": "Manipur",
        "197": "Meghalaya",
        "198": "Mizoram",
        "199": "Nagaland",
        "200": "Nationaal Hoofdstedelijk Territorium van Delhi",
        "201": "Odisha",
        "202": "Puducherry",
        "203": "Punjab",
        "204": "Rajasthan",
        "205": "Sikkim",
        "206": "Tamil Nadu",
        "207": "Telangana",
        "208": "Tripura",
        "209": "Uttar Pradesh",
        "210": "Uttarakhand",
        "211": "West-Bengalen",
        "212": "Nieuw-Zuid-Wales",
        "213": "Queensland",
        "214": "Zuid-Australië",
        "215": "Tasmanië",
        "216": "Victoria",
        "217": "West-Australië",
        "218": "Noordelijk Territorium",
        "219": "Pacifische Eilanden",
        "220": "PNG",
        "221": "Adana",
        "222": "Adıyaman",
        "223": "Afyonkarahisar",
        "224": "Ağri",
        "225": "Aksaray",
        "226": "Amasya",
        "227": "Ankara",
        "228": "Antalya",
        "229": "Ardahan",
        "230": "Artvin",
        "231": "Aydın",
        "232": "Balıkesir",
        "233": "Bartın",
        "234": "Batman",
        "235": "Bayburt",
        "236": "Bilecik",
        "237": "Bingöl",
        "238": "Bitlis",
        "239": "Bolu",
        "240": "Burdur",
        "241": "Bursa",
        "242": "Çanakkale",
        "243": "Çankırı",
        "244": "Çorum",
        "245": "Denizli",
        "246": "Diyarbakır",
        "247": "Düzce",
        "248": "Edirne",
        "249": "Elazığ",
        "250": "Erzincan",
        "251": "Erzurum",
        "252": "Eskişehir",
        "253": "Gaziantep",
        "254": "Giresun",
        "255": "Gümüşhane",
        "256": "Hakkari",
        "257": "Hatay",
        "258": "Iğdır",
        "259": "Isparta",
        "260": "Istanboel",
        "261": "Kahramanmaraş",
        "262": "Karabük",
        "264": "Karaman",
        "265": "Kars",
        "266": "Kastamonu",
        "267": "Kayseri",
        "268": "Kilis",
        "269": "Kırıkkale",
        "270": "Kırklareli",
        "271": "Kırşehir",
        "272": "Kocaeli",
        "273": "Konya",
        "274": "Kütahya",
        "275": "Malatya",
        "276": "Manisa",
        "277": "Mardin",
        "278": "Mersin",
        "279": "Muğla",
        "280": "Muş",
        "281": "Nevşehir",
        "282": "Niğde",
        "283": "Ordu",
        "284": "Osmaniye",
        "285": "Rize",
        "286": "Sakarya",
        "287": "Samsun",
        "288": "Şanlıurfa",
        "289": "Siirt",
        "290": "Sinop",
        "291": "Şırnak",
        "292": "Sivas",
        "293": "Tekirdağ",
        "294": "Tokat",
        "295": "Trabzon",
        "296": "Tunceli",
        "297": "Uşak",
        "298": "Van",
        "299": "Yalova",
        "300": "Yozgat",
        "301": "Baja California",
        "302": "Baja California Sur",
        "303": "Chihuahua",
        "304": "Durango",
        "305": "Sinaloa",
        "306": "Sonora",
        "307": "Coahuila",
        "308": "Nuevo",
        "309": "León",
        "310": "Tamaulipas",
        "311": "Aguascalientes",
        "312": "Guanajuato",
        "313": "Querétaro",
        "314": "San Luis Potosí",
        "315": "Zacatecas",
        "316": "Federaal District",
        "317": "Mexico",
        "318": "Morelos",
        "319": "Colima",
        "320": "Jalisco",
        "321": "Michoacán",
        "322": "Nayarit",
        "323": "Hidalgo",
        "324": "Puebla",
        "325": "Tlaxcala",
        "326": "Veracruz",
        "327": "Campeche",
        "328": "Quintana Roo",
        "329": "Tabasco",
        "330": "Yucatán",
        "331": "Chiapas",
        "332": "Guerrero",
        "333": "Oaxaca",
        "334": "Brits-Columbia",
        "335": "Alberta",
        "336": "Saskatchewan",
        "337": "Manitoba",
        "338": "Ontario",
        "339": "Quebec",
        "340": "New Brunswick",
        "341": "Prins Edwardeiland",
        "342": "Nova Scotia",
        "343": "Newfoundland en Labrador",
        "344": "Yukon",
        "345": "Noordwest",
        "346": "Territoria",
        "347": "Nunavut",
        "348": "Alabama",
        "349": "Alaska",
        "350": "Arizona",
        "351": "Arkansas",
        "352": "Californië",
        "353": "Colorado",
        "354": "Connecticut",
        "355": "Delaware",
        "356": "Florida",
        "357": "Georgia",
        "358": "Hawaï",
        "359": "Idaho",
        "360": "Illinois",
        "361": "Indiana",
        "362": "Iowa",
        "363": "Kansas",
        "364": "Kentucky",
        "365": "Louisiana",
        "366": "Maine",
        "367": "Maryland",
        "368": "Massachusetts",
        "369": "Michigan",
        "370": "Minnesota",
        "371": "Mississippi",
        "372": "Missouri",
        "373": "Montana",
        "374": "Nebraska",
        "375": "Nevada",
        "376": "New Hampshire",
        "377": "New Jersey",
        "378": "New Mexico",
        "379": "New York",
        "380": "North Carolina",
        "381": "North",
        "382": "Dakota",
        "383": "Ohio",
        "384": "Oklahoma",
        "385": "Oregon",
        "386": "Pennsylvania",
        "387": "Rhode Island",
        "388": "South-Carolina",
        "389": "South-Dakota",
        "390": "Tennessee",
        "391": "Texas",
        "392": "Utah",
        "393": "Vermont",
        "394": "Virginia",
        "395": "Washington",
        "396": "West Virginia",
        "397": "Wisconsin",
        "398": "Wyoming",
        "399": "Abruzzo",
        "400": "Aostadal",
        "401": "Apulia",
        "402": "Basilicata",
        "403": "Calabrië",
        "404": "Campanië",
        "405": "Emilia-Romagna",
        "406": "Friuli-Venezia Giulia",
        "407": "Lazio",
        "408": "Ligurië",
        "409": "Lombardije",
        "410": "Marche",
        "411": "Molise",
        "412": "Piedmont",
        "413": "Sardinië",
        "414": "Sicilië",
        "415": "Trentino-Zuid-Tirol",
        "416": "Toscane",
        "417": "Umbrië",
        "418": "Veneto",
        "419": "Acre",
        "420": "Alagoas",
        "421": "Amapá",
        "422": "Amazonas",
        "423": "Bahia",
        "424": "Ceará",
        "425": "Federaal District",
        "426": "Espírito Santo",
        "427": "Goiás",
        "428": "Maranhão",
        "429": "Mato Grosso",
        "430": "Mato Grosso do Sul",
        "431": "Minas Gerais",
        "432": "Pará",
        "433": "Paraíba",
        "434": "Paraná",
        "435": "Pernambuco",
        "436": "Piauí",
        "437": "Rio de Janeiro",
        "438": "Rio Grande do Norte",
        "439": "Rio Grande do Sul",
        "440": "Rondônia",
        "441": "Roraima",
        "442": "Santa Catarina",
        "443": "São Paulo",
        "444": "Sergipe",
        "445": "Tocantins",
        "446": "Grand Est (Alsace-Champagne-Ardenne-Lorraine)",
        "447": "Nouvelle-Aquitaine (Aquitaine-Limousin-Poitou-Charentes)",
        "448": "Auvergne-Rhône-Alpes",
        "449": "Bourgogne-Franche-Comté",
        "450": "Bretagne",
        "451": "Centre-Val de Loire",
        "452": "Corsica",
        "453": "Île-de-France",
        "454": "Occitanië (Languedoc-Roussillon-Midi-Pyrénées)",
        "455": "Hauts-de-France (Nord-Pas-de-Calais-Picardy)",
        "456": "Normandië",
        "457": "Pays de la Loire",
        "458": "Provence-Alpes-Côte d`Azur",
        Territory: "Territory",
        Anhui: "Anhui",
        Beijing: "Beijing",
        "Chinese Taipei": "Chinese Taipei",
        "Chong Qing": "Chong Qing",
        Fujian: "Fujian",
        Gansu: "Gansu",
        Guangdong: "Guangdong",
        Guangxi: "Guangxi",
        Guizhou: "Guizhou",
        Hainan: "Hainan",
        Hebei: "Hebei",
        Heilongjiang: "Heilongjiang",
        Henan: "Henan",
        "Hong Kong": "Hong Kong",
        Hubei: "Hubei",
        Hunan: "Hunan",
        Jiangsu: "Jiangsu",
        Jiangxi: "Jiangxi",
        Jilin: "Jilin",
        Liaoning: "Liaoning",
        Macao: "Macao",
        "Nei Mongol": "Nei Mongol",
        Ningxia: "Ningxia",
        Qinghai: "Qinghai",
        Shaanxi: "Shaanxi",
        Shandong: "Shandong",
        Shanghai: "Shanghai",
        Shanxi: "Shanxi",
        Sichuan: "Sichuan",
        Tianjin: "Tianjin",
        Xinjiang: "Xinjiang",
        Xizang: "Xizang",
        Yunnan: "Yunnan",
        Zhejiang: "Zhejiang",
    },
};

export default countriesAndRegions;
